import { render, staticRenderFns } from "./Haustypen.vue?vue&type=template&id=609b788c"
import script from "./Haustypen.vue?vue&type=script&lang=js"
export * from "./Haustypen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports